export default __webpack_public_path__ + "static/media/info-svgrepo-com.93af6c70.png";